import bootstrap from 'bootstrap';

class BannerScroll {

    init() {
        const scrollElements = document.querySelectorAll(".sc-banner-image");

        window.addEventListener('scroll', () => {
            this.handleScrollAnimation(scrollElements);
        })

    }

    elementInView(el, percentageScroll) {
        const elementTop = el.getBoundingClientRect().top;

        return (
            elementTop <=
            ((window.innerHeight || document.documentElement.clientHeight) * (percentageScroll / 100))
        )
    }

    addFade(element) {
        element.classList.add("scrolled");
    }

    removeFade(element) {
        element.classList.remove("scrolled");
    }

    handleScrollAnimation(scrollElements) {
        scrollElements.forEach((elemt) => {
            if (this.elementInView(elemt, 7)) {
                this.addFade(elemt);
            } else {
                this.removeFade(elemt);
            }
        })
    }

}

export default BannerScroll;